import { Button } from 'antd';
import type { RateLineImportCommitRow } from '../../../rate-cards.api';
import { RateLineImportCommitResults } from './RateLineImportCommitResults';

interface RateLineImportCommittedPanelProps {
  rows: RateLineImportCommitRow[];
  onGoToProposals: () => void;
  onImportAnother: () => void;
}

/** What committing actually did, with the two places to go next: the queue the proposals landed in, or another file. */
export function RateLineImportCommittedPanel({ rows, onGoToProposals, onImportAnother }: RateLineImportCommittedPanelProps) {
  return (
    <div className="flex flex-col gap-4">
      <RateLineImportCommitResults rows={rows} />
      <div className="flex gap-2">
        <Button type="primary" onClick={onGoToProposals}>
          Go to proposals
        </Button>
        <Button onClick={onImportAnother}>Import another file</Button>
      </div>
    </div>
  );
}
